import { useQuery } from '@tanstack/react-query';

import type { ObtainMethod } from '@frontend/api';
import { useRequest, type QueryFunction } from '@frontend/api/src/common';

type ComponentData = {
  id: number;
  partUuid: string;
  isRootComponent: boolean;
  filename: string;
  partNumber: null | string;
  revision: null | string;
  obtainMethod: ObtainMethod;
  isAssembly: boolean;
  innateQuantity: number;
  containsVirus: boolean;
  canBeNewParent: boolean;
  searchName: string;
};

type NodeData = {
  id: number;
  childUuid: string;
  count: number;
  position: number;
};

export type BOMRestructureInfo = {
  components: ComponentData[];
  nodes: NodeData[];
};

type UseGetBOMRestructureInfoParams = {
  quoteItemId: number;
};

export type GetBOMRestructureInfoQueryKeyType = readonly [
  'bomRestructureInfo',
  number,
];

export const getBOMRestructureInfoQueryKey = (
  params: UseGetBOMRestructureInfoParams,
): GetBOMRestructureInfoQueryKeyType => [
  'bomRestructureInfo',
  params.quoteItemId,
];

export const useGetBOMRestructureInfo: QueryFunction<
  BOMRestructureInfo,
  [UseGetBOMRestructureInfoParams],
  GetBOMRestructureInfoQueryKeyType
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getBOMRestructureInfoQueryKey(params);

  return useQuery<
    BOMRestructureInfo,
    unknown,
    BOMRestructureInfo,
    GetBOMRestructureInfoQueryKeyType
  >({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) => {
      return request(
        `/quotes/items/${params.quoteItemId}/bom_restructure_info/`,
        {
          init: {
            method: 'GET',
            signal,
          },
        },
      );
    },
  });
};
